export const DEFAULT_TITLE = 'Confirm Action';
export const DEFAULT_MESSAGE = "Are you sure? You can't undo this action afterwards.";
export const DEFAULT_CONFIRM_TEXT = 'Confirm';
export const DEFAULT_CANCEL_TEXT = 'Cancel';
export const DEFAULT_CONFIRM_COLOR_SCHEME: 'red' | 'blue' | 'green' | 'orange' | 'purple' = 'red';
export const DEFAULT_WIDTH = 520;
export const DEFAULT_CENTERED = true;
export const DEFAULT_CLOSABLE = true;
export const DEFAULT_MASK_CLOSABLE = true;
export const DEFAULT_LOADING = false;

export const ICON_MAP = {
  danger: 'faExclamationTriangle',
  warning: 'faExclamationCircle',
  info: 'faInfoCircle',
  success: 'faCheckCircle',
} as const;

export const COLOR_SCHEME_MAP = {
  red: 'danger',
  blue: 'info',
  green: 'success',
  orange: 'warning',
  purple: 'info',
} as const;
